
import { Store } from "backend";
import clsx from "clsx";
import * as React from "react";

import defaultImage from "../../assets/shamiko.jpg";
import { LoadingSpinner } from "./utils/LoadingSpinner";
import _styles from "./TeamImage-styles.module.scss";


const styles = _styles;

export function TeamImage(props: {
	teamImage: string;
	className?: string;
	imageClassName?: string;
}) {
	return <div
		className={clsx(styles.container, props.className)}
	>
		{props.teamImage === undefined
			? <LoadingSpinner />
			: <img src={props.teamImage ?? defaultImage} className={clsx(props.imageClassName, styles.image)} />
		}
	</div>;
}
